import { api } from "./index";

export type ActivityAction =
  | 'company_updated'
  | 'user_added'
  | 'user_updated'
  | 'user_removed'
  | 'permissions_updated'
  | 'role_added'
  | 'role_updated'
  | 'role_removed'
  | 'activation_settings_updated'
  | 'payment_method_updated';

export interface ActivityActor {
  id: string;
  full_name: string | null;
  avatar: string | null;
  role: { id: string; name: string } | null;
}

export interface ActivityItem {
  id: string;
  action: ActivityAction;
  created_at: string;
  actor: ActivityActor | null;
  target_type: string | null;
  target_id: string | null;
  target_label: string | null;
  before: unknown;
  after: unknown;
}

export interface CompanyActivityResponse {
  items: ActivityItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CompanyActivityParams {
  actorUserId?: string;
  role?: string;
  from?: string;
  to?: string;
  search?: string;
  sort?: string;
  page?: number;
  pageSize?: number;
}

export const companyActivityApi = {
  async getCompanyActivity(
    params?: CompanyActivityParams
  ): Promise<CompanyActivityResponse> {
    const response = await api.get("/companies/admin/me/activity", { params });
    return response.data;
  },
};
